import { render } from "./FlexSlider2.vue?vue&type=template&id=7417dc33&scoped=true"
import script from "./FlexSlider2.vue?vue&type=script&lang=js"
export * from "./FlexSlider2.vue?vue&type=script&lang=js"

import "./FlexSlider2.vue?vue&type=style&index=0&id=7417dc33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7417dc33"]])

export default __exports__